(() => {
  function prepare(root = document) {
    root.querySelectorAll('[data-products-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';
      const section = carousel.closest('.reference-products');
      const controls = section?.querySelector('.reference-products__carousel-controls');
      const previous = controls?.querySelector('[data-products-prev]');
      const next = controls?.querySelector('[data-products-next]');
      if (!previous || !next) return;

      const update = () => {
        const scrollable = carousel.scrollWidth > carousel.clientWidth + 2;
        controls.hidden = !scrollable;
        previous.disabled = !scrollable || carousel.scrollLeft <= 2;
        next.disabled = !scrollable || carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
      };
      const move = (direction) => {
        const card = carousel.querySelector('.reference-products__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
        carousel.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      carousel.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  } else {
    prepare();
  }
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
